export default __webpack_public_path__ + "static/imperfective-imperative-d083bd654c64f8d0109a3d8c0054a6e7.svg";